import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SideNav from '../../components/customComponents/sideNav/SideNav';
import { brandNavigations } from '../../NavigationData';
import { getBrandProfile, getUnreadNotificationCount } from '../../store/actions';
import styles from '../AdminDashboard/adminDashboard.module.scss';

export default function BrandDashboardLayout() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBrandProfile());
    dispatch(getUnreadNotificationCount());
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <SideNav navigations={brandNavigations} navTheme="brand" />
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
}
